var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DDQ, getWidget, } from "@api/utils";
import { getOOrder } from "./get-o-order";
import config from "@api/config";
var TrackingOrderView = /*@__PURE__*/ (function () {
    function TrackingOrderView() {
    }
    TrackingOrderView.prototype.getPageview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pageType, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pageType = window.VF.pageType;
                        if (config.TEALIUM_ENVIRONMENT) {
                            window.VF.tealiumEnvironment = "autotest";
                        }
                        if ((getWidget("kiss-devices") || getWidget("kiss-tariffs")) &&
                            !getWidget("kiss-device-detail")) {
                            pageType = "product listing";
                        }
                        if (TrackingOrderView.count > 0 || getWidget("kiss-device-detail")) {
                            pageType = "product detail";
                        }
                        TrackingOrderView.count++;
                        _a = {
                            tealiumEnvironment: window.VF.tealiumEnvironment,
                            tealiumUseDCF: window.VF.tealiumUseDCF,
                            customTracking: window.VF.customTracking,
                            siteStructure: window.VF.siteStructure,
                            pageType: pageType,
                            siteArea: window.VF.siteArea,
                            loginStatus: -1 != document.cookie.indexOf("MDDKeks")
                                ? "logged in"
                                : "not logged in",
                            platformType: window.VF.platformType,
                            lineOfCustomer: window.VF.lineOfCustomer,
                            businessTransactionType: window.VF.businessTransactionType,
                            flowType: window.VF.flowType
                        };
                        return [4 /*yield*/, getOOrder()];
                    case 1: return [2 /*return*/, (_a.oOrder = _b.sent(),
                            _a)];
                }
            });
        });
    };
    TrackingOrderView.prototype.track = function () {
        var _this = this;
        if (window.eShopBasket)
            return;
        return new Promise(function (resolve, reject) {
            return __awaiter(_this, void 0, void 0, function () {
                var data, listener;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getPageview()];
                        case 1:
                            data = _a.sent();
                            if (JSON.stringify(data) === TrackingOrderView.hash) {
                                return [2 /*return*/, resolve()];
                            }
                            TrackingOrderView.hash = JSON.stringify(data);
                            DDQ.push(["pageview", data]);
                            listener = function () {
                                resolve();
                            };
                            DDQ.on("pageview", function () {
                                if (listener) {
                                    listener();
                                }
                                listener = null;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    TrackingOrderView.count = 0;
    return TrackingOrderView;
}());
export { TrackingOrderView };
var TrackingDeviceFilter = /*@__PURE__*/ (function () {
    function TrackingDeviceFilter() {
    }
    TrackingDeviceFilter.prototype.setAction = function (action) {
        this.action = action;
        return this;
    };
    TrackingDeviceFilter.prototype.setUpdatedFilter = function (updatedFilter) {
        this.updatedFilter = updatedFilter;
        return this;
    };
    TrackingDeviceFilter.prototype.setAppliedFilters = function (appliedFilters) {
        this.appliedFilters = appliedFilters;
        return this;
    };
    TrackingDeviceFilter.prototype.getFilterProducts = function () {
        return {
            action: this.action,
            updatedFilter: this.updatedFilter,
            appliedFilters: this.appliedFilters,
        };
    };
    TrackingDeviceFilter.prototype.track = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return __awaiter(_this, void 0, void 0, function () {
                var listener;
                return __generator(this, function (_a) {
                    DDQ.push(["filter products", this.getFilterProducts()]);
                    listener = function () {
                        resolve();
                    };
                    DDQ.on("filter products", function () {
                        if (listener) {
                            listener();
                        }
                        listener = null;
                    });
                    return [2 /*return*/];
                });
            });
        });
    };
    return TrackingDeviceFilter;
}());
export { TrackingDeviceFilter };
var TrackingOptionSwitch = /*@__PURE__*/ (function () {
    function TrackingOptionSwitch() {
        this.selectedOption = [];
        this.removedOption = [];
    }
    TrackingOptionSwitch.prototype.addSelectedOption = function (name, type, sku, priceMonthly, proposition) {
        this.selectedOption.push({
            name: "Business " + name,
            type: type,
            sku: sku,
            priceMonthly: priceMonthly.toFixed(2) + "",
            priceOnce: "0.00",
            proposition: proposition,
        });
        return this;
    };
    TrackingOptionSwitch.prototype.addRemovedOption = function (name, type, sku, priceMonthly, proposition) {
        if (this.removedOption) {
            this.removedOption.push({
                name: "Business " + name,
                type: type,
                sku: sku,
                priceMonthly: priceMonthly.toFixed(2) + "",
                priceOnce: "0.00",
                proposition: proposition,
            });
        }
        return this;
    };
    TrackingOptionSwitch.prototype.getOptionSwitch = function () {
        if (this.removedOption.length === 0) {
            this.removedOption = undefined;
        }
        return {
            selectedOption: this.selectedOption,
            removedOption: this.removedOption,
        };
    };
    TrackingOptionSwitch.prototype.track = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return __awaiter(_this, void 0, void 0, function () {
                var listener;
                return __generator(this, function (_a) {
                    DDQ.push(["switch options", this.getOptionSwitch()]);
                    listener = function () {
                        resolve();
                    };
                    DDQ.on("switch options", function () {
                        if (listener) {
                            listener();
                        }
                        listener = null;
                    });
                    return [2 /*return*/];
                });
            });
        });
    };
    return TrackingOptionSwitch;
}());
export { TrackingOptionSwitch };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/tracking/tracking.order-flow.ts
// module id = null
// module chunks = 